export const parseTime = (seconds) => {
    let minutes = ~~(seconds/60);
    seconds = seconds % 60;
    return {
        minutes: (minutes < 10) ? `0${minutes}` : `${minutes}`,
        seconds: (seconds < 10) ? `0${seconds}` : `${seconds}`  
    }
}